import styled from "styled-components";

export const StyledPollItemWrapper = styled.div`
    background: #fff;
    border-radius: 4px;
    padding: 8px;
    margin: 12px 0;
    position: relative;
`;

export const PollLefTimeWrapper = styled.div`
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: flex-end;
`;

export const ClosePollContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    justify-content: flex-end;
    align-items: center;
    color: red;
`;
export const ClosePollIcon = styled.div`
    height: 30px;
    width: 30px;
    background-repeat: no-repeat;
    background-image: url("/images/closedPoll.svg");
    background-position: center;
    background-size: cover;
`;

export const StyledDragHandle = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a0a0a0;
`;
